import { render, staticRenderFns } from "./WorkspaceExpandedNav.vue?vue&type=template&id=7664ac4c&scoped=true&"
import script from "./WorkspaceExpandedNav.vue?vue&type=script&lang=js&"
export * from "./WorkspaceExpandedNav.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceExpandedNav.vue?vue&type=style&index=0&id=7664ac4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7664ac4c",
  null
  
)

export default component.exports